export function truncateDecimal(input, decimalPlaces = 2) {
    let number = parseFloat(input);
    return Number.isInteger(number) ? number : parseFloat(number.toFixed(decimalPlaces));
}